import { getField, updateField } from 'vuex-map-fields';

export default {
  name: 'trustPendingRecord',
  namespaced: true,
  state: {
    disable: false,
  },
  getters: {
    getField,
    trustPendingRecord: (state) => state,
  },
  mutations: {
    updateField,
  },
};
